/**
 * This script toggles burger navigation
 */

export enum Bodystate {
	visible = 'state-m-burgernav--visible',
	sticky = 'no-scrolling--without-scrollbar',
	scrollbar = 'no-scrolling--without-scrollbar',
}

const classes = {
	outerParent: 'body',
	stateBurgerNav: Bodystate.visible,
	noScrolling: Bodystate.scrollbar,
};

/**
 * change the current burger state
 *
 * @param handler
 * @returns {void}
 */
export function changeBodyState(bodyClass: string): void {
	$(`${classes.outerParent}`).toggleClass(bodyClass);
}

/**
 * removes the current burger state
 *
 * @param handler
 * @returns {()=>JQuery}
 */
export function removeBodyState(bodyClass: string) {
	$(`${classes.outerParent}`).removeClass(bodyClass);
}

/**
 * Returns the current burger State
 */
export function getBodyState(bodyClass: string): boolean {
	return $(`${classes.outerParent}`).hasClass(bodyClass);
}

export default { changeBodyState, getBodyState };

$(window).on('lockScrolling', () => {
	$('html').addClass(classes.noScrolling);
});

$(window).on('unlockScrolling', () => {
	$('html').removeClass(classes.noScrolling);
});
